import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['fields', 'template', 'fieldAppendContainer']

  connect() {
    let renderedFields = this.fieldsTarget.getAttribute('data-rendered-fields')
    const select = this.fieldAppendContainerTarget.querySelector('.select-field')

    // Hide initially selected fields from select
    for (let i = 0; i < select.options.length; i++) {
      let item = select.options[i];

      if (renderedFields.includes(item.value)) {
        item.disabled = true;
        item.style.display = 'none';
      }
    }

    select.value = select.options[0].value
    select.dispatchEvent(new Event('change'))
  }

  appendField(event) {
    const select = this.fieldAppendContainerTarget.querySelector('.select-field')
    let selectedOption = select.options[select.selectedIndex]
    let selectValue = selectedOption.value

    if (selectValue == '') return

    // Hide selected field from select
    selectedOption.disabled = true;
    selectedOption.style.display = 'none';

    select.value = select.options[0].value
    select.dispatchEvent(new Event('change'))

    // Show field template
    let content = this.templateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, selectValue)
    this.fieldsTarget.insertAdjacentHTML('beforebegin', content)
  }

  removeField(event) {
    let fieldHolder = event.target.closest('.field-holder')
    let field = fieldHolder.querySelector('.text-field')
    let fieldName = field.getAttribute('data_field_name')

    // Hide and disable field
    fieldHolder.style.display = 'none'
    field.disabled = true

    const select = this.fieldAppendContainerTarget.querySelector('.select-field')

    // Show fields in select after they are removed from GUI
    for (let i = 0; i < select.options.length; i++) {
      let item = select.options[i];

      if (item.value == fieldName) {
        item.disabled = false;
        item.style.display = 'block';

        select.value = select.options[0].value
        select.dispatchEvent(new Event('change'))
        break;
      }
    }
  }
}
